<div class="modal-body">
    Are you sure?
</div>
<div class="modal-footer">
    <button class="btn sk-btn-primary" (click)="close(true)">OK</button>
    <button class="btn sk-btn-light" (click)="close(false)">Cancel</button>
</div>